module.exports = __webpack_public_path__ + "static/media/goblin.1236860b.png";